import { connect } from 'formik';
import React, { ChangeEvent, Component, PropsWithChildren } from 'react';
import { RegisterElement } from '..';
import { IRadioProps } from '../Input';
import { getDescribedBy } from '../Input/inputUtils';
import { FieldHelpersWrapper } from '../utils/formHelpers';
import { resolveProps } from '../utils/formikUtils';
import { createId } from '../utils/IdGenerator';
import './Radio.scss';
import { RadioLabel } from './RadioLabel';
import { InnerRadioProps } from './types';

export class Radio extends Component<PropsWithChildren<InnerRadioProps>, {}> {
  private id = this.props.id || createId('radio');

  public componentDidMount() {
    this.props.formik.registerField && this.props.formik.registerField(this.props.name, this);
  }

  public componentWillUnmount() {
    this.props.formik.unregisterField && this.props.formik.unregisterField(this.props.name);
  }

  public render() {
    const { id } = this;
    const {
      name,
      helpText,
      groupLabel,
      onChange,
      displaySuccess,
      formik,
      validate,
      inline,
      required = false,
      ...inputAttrsProps
    } = this.props;
    const { valid = true, touched = false, value, onBlur } = resolveProps(this.props, this.props.formik);
    const showError = touched && !valid;
    const describedBy = getDescribedBy({
      hasErrors: showError,
      hasHelpText: !!helpText,
      id,
    });

    return (
      <RegisterElement name={`register-${id}`}>
        {(ref: any) => {
          const myRef = showError ? ref : undefined;
          return (
            <div
              ref={myRef}
              className="hlc-radiogroup"
              role="radio-group"
              id={id}
              aria-invalid={!valid}
              aria-describedby={describedBy}
              qa-id={this.props['qa-id']}
            >
              <FieldHelpersWrapper id={id} props={this.props} useGroupLabel={true}>
                {this.props.options.map((option, i: number) => {
                  const isChecked = option.value === value;

                  /**
                   * We're allowing numeric values for radio options
                   * This ensures number in -> number out and
                   * string in -> string out
                   */
                  const handleRadioChange = (e: ChangeEvent<HTMLInputElement>) => {
                    let val: any;
                    if (typeof option.value === 'string') {
                      val = e.target.value;
                    } else {
                      val = +e.target.value;
                    }

                    if (this.props.onChange) {
                      this.props.onChange(name, val);
                    } else if (Object.keys(this.props.formik).length) {
                      this.props.formik.setFieldValue(name || id, val);
                    }
                  };
                  return (
                    <RadioLabel key={i} inline={inline}>
                      <input
                        {...inputAttrsProps}
                        id={`${id}-${i}`}
                        name={name}
                        type={'radio'}
                        value={option.value}
                        checked={isChecked}
                        onChange={handleRadioChange}
                        onBlur={onBlur}
                      />{' '}
                      {option.label}
                    </RadioLabel>
                  );
                })}
              </FieldHelpersWrapper>
            </div>
          );
        }}
      </RegisterElement>
    );
  }
}

export default connect<IRadioProps>(Radio);
